import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PageHeader, DataTable } from "@/components/admin/ui";
import { useFetch } from "@/hooks/useFetch";
import { formatDate } from "@/lib/api";

export default function Parents() {
  const navigate = useNavigate();
  const [q, setQ] = useState("");
  const { data, loading } = useFetch(`/admin/parents?q=${encodeURIComponent(q)}`);
  return (
    <div data-testid="parents-page">
      <PageHeader eyebrow="Families" title="Parents" description="All parent accounts, whether self sign-up or created by admin." />
      <div className="relative max-w-sm mb-4">
        <Search className="h-4 w-4 absolute left-3 top-1/2 -translate-y-1/2 text-[#8a7686]" />
        <Input placeholder="Search name or email" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9 h-10 bg-white" data-testid="parents-search-input" />
      </div>
      <DataTable testId="parents-table" loading={loading} rows={data} onRowClick={(r) => navigate(`/admin/parents/${r.id}`)} columns={[
        { key: "name", label: "Name", render: (r) => <span className="font-semibold">{r.name}</span> },
        { key: "email", label: "Email" },
        { key: "student_count", label: "Students" },
        { key: "source", label: "Source", render: (r) => (r.source === "admin_provisioned" ? "Admin" : "Self sign-up") },
        { key: "email_verified", label: "Email", render: (r) => (r.email_verified ? "Verified" : r.password_set ? "Unverified" : "Setup pending") },
        { key: "status", label: "Status", render: (r) => <span className={r.status === "disabled" ? "text-rose-700 font-semibold" : "text-emerald-700"}>{r.status}</span> },
        { key: "created_at", label: "Joined", render: (r) => formatDate(r.created_at) },
      ]} />
    </div>
  );
}
